import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const CanvasPlanTasksGridViewLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-canvasplantasksgridview" */ "./CanvasPlanTasksGridView")).then((page)=>{
        return {
            default: page.CanvasPlanTasksGridView
        };
    });
export const LazyCanvasPlanTasksGridView = /*#__PURE__*/ lazy(CanvasPlanTasksGridViewLazyLoader);
